module.exports = __webpack_public_path__ + "img/cadeado-desbloqueado.64fe4516.svg";